import React, { useState } from 'react';
import { Button } from '@asigna/kit';
import { ToastTooltip } from 'components/ToastTooltip';
import useSafe from 'hooks/use-safe';
import closeIcon from 'images/close.svg';
import CopyChecked from 'images/copy_checked.svg';
import CopyIcon from 'images/copy_icon.svg';
import { QRCodeSVG } from 'qrcode.react';

import { useReceiveBtcDialogStyles } from './style';

interface TransactionCommonProps {
  address: string;
  onClose: () => void;
}

export const ReceiveBtcDialog: React.FC<TransactionCommonProps> = ({ address, onClose }) => {
  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);
  const { safe } = useSafe();

  const onCopyClicked = () => {
    navigator.clipboard.writeText(safe.address || '');
    if (copyTooltipOpen) {
      return;
    }
    setCopyTooltipOpen(true);
    setTimeout(() => {
      setCopyTooltipOpen(false);
    }, 3 * 1000);
  };

  const classes = useReceiveBtcDialogStyles();

  return (
    <div className="flex flex-col gap-16">
      <div className="flex items-center justify-between">
        <p className="text-r20">Vault address</p>
        {/* TODO Icon Button */}
        <Button
          leftIcon={closeIcon}
          onClick={onClose}
          colorType="inherit"
          size="sm"
          className="w-40 h-40 border-[.5px] border-black-4 !px-0 hover:bg-white-3"
        />
      </div>

      <div className={classes.wrapper}>
        <span className={classes.description}>
          Use the vault address to deposit any Stacks assets
        </span>
        <div className={classes.qrcode}>
          <div
            className={classes.copyCode}
            onClick={(e) => {
              e.stopPropagation();
              onCopyClicked();
            }}
          >
            <p>{safe.address}</p>
            <ToastTooltip
              style={{ width: '80%' }}
              open={copyTooltipOpen}
              message="Copied"
              icon={CopyChecked}
              placement="top"
            >
              <img src={CopyIcon} width={24} height={24} alt="copy icon" />
            </ToastTooltip>
          </div>
          {safe && (
            <div className={classes.imageWrapper}>
              <QRCodeSVG value={safe.address} size={178} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
